// @flow
import get from 'lodash/get';
import reduce from 'lodash/reduce';
import type { State } from './form-submitter-type';

const defaultSelectedValues = [];
const defaultTextValue = '';
const defaultItemsArray = [];
const defaultItemsInUploadQueueArray = [];
const defaultDateValue = '';
const defaultError = null;

export default {
  getTextValueForId: (state: State, id: string) => {
    const value = get(state, `response.${id}`, defaultTextValue);
    return value;
  },
  getDateValueForId: (state: State, id: string) => {
    const value = get(state, `response.${id}`, defaultDateValue);
    return value;
  },
  getSelectedValuesForId: (state: State, id: string) => {
    const values = get(state, `response.${id}`, defaultSelectedValues);
    return values;
  },
  getErrorForId: (state: State, id: string) => {
    const error = get(state, `errors.${id}`, defaultError);
    return error;
  },
  getItemsForId: (state: State, id: string) => {
    const items = get(state, `itemQueues.${id}.items`, defaultItemsArray);
    return items;
  },
  getComponentForId: (state: State, id: string) => {
    const component = get(state, `components.${id}`);
    return component;
  },
  countAllItemsInItemQueues: (state: State) => {
    return reduce(
      state.itemQueues,
      (acc, queue) => {
        return acc + queue.items.length;
      },
      0,
    );
  },
  getAllItemsInItemQueues: (state: State) => {
    return reduce(
      state.itemQueues,
      (acc, queue) => {
        return [...acc, ...queue.items];
      },
      [],
    );
  },
  getAllItemsInUploadQueue: (state: State) => {
    return get(
      state,
      `uploader.itemsInUploadQueue`,
      defaultItemsInUploadQueueArray,
    );
  },
  getPageLayout: (state: State) => {
    return get(state, `form.content.layouts.group-0.layout`, undefined);
  },
};
